import {
  Checkbox,
  Error,
  Errors,
  Field,
  Input,
  InputWrapper,
  Label,
  Radio,
  RadioGroup,
  SubmitButton,
  TextArea
} from '@swaggerhub-portal/component-library'
import { Form as ReactRouterForm, useActionData, useNavigation, useSubmit } from 'react-router'
import { FormProps, FormSchema, createForm } from 'remix-forms'

const BaseForm = createForm({
  component: ReactRouterForm,
  useNavigation,
  useSubmit,
  useActionData,
}) as any

export default function Form<Schema extends FormSchema>(
  props: FormProps<Schema>,
) {
  return (
    <BaseForm
      className="flex flex-col space-y-6"
      fieldComponent={Field}
      labelComponent={Label}
      inputComponent={Input}
      multilineComponent={TextArea}
      radioComponent={Radio as any}
      radioGroupComponent={RadioGroup}
      radioWrapperComponent={InputWrapper}
      checkboxWrapperComponent={InputWrapper}
      checkboxComponent={Checkbox}
      buttonComponent={SubmitButton}
      globalErrorsComponent={Errors}
      errorComponent={Error}
      {...props}
    />
  )
}